const SET_REQUEST_ID = 'FORGOT/SET_REQUEST_ID'
const SET_MASKED_DATA = 'FORGOT/SET_MASKED_DATA'
const SET_FORGOT_PROFILE = 'FORGOT/SET_FORGOT_PROFILE'
const SET_FORGOT_STEP = 'FORGOT/SET_FORGOT_STEP'
const SET_REQUEST_TOKEN = 'FORGOT/SET_REQUEST_TOKEN'
// TODO: add more action types if necessary

export {
  SET_REQUEST_ID,
  SET_MASKED_DATA,
  SET_FORGOT_PROFILE,
  SET_FORGOT_STEP,
  SET_REQUEST_TOKEN,
  // TODO: export action types added later
}
